export default {
  heading: 'Procházet hry',
  filters: {
    title: 'Filtry',
    clearAll: 'Zrušit filtry',
    closeAriaLabel: 'Zavřít filtry',
    openButton: 'Filtry',
    inStockOnly: 'Pouze skladem',
    preorderOnly: 'Pouze předobjednávky',
    category: 'Kategorie',
    comingSoon: 'Již brzy',
    priceRange: 'Cenové rozpětí',
    minEur: 'Min €',
    maxEur: 'Max €',
    showResults: 'Zobrazit {count} výsledek | Zobrazit {count} výsledky | Zobrazit {count} výsledků',
    showMore: '+ Zobrazit dalších {count}',
    showLess: '− Zobrazit méně',
    minPriceAriaLabel: 'Minimální cena',
    maxPriceAriaLabel: 'Maximální cena',
  },
  chips: {
    search: 'Hledání: {term}',
    includingSoldOut: 'Včetně vyprodaných',
    priceFrom: 'Od {min} €',
    priceUpTo: 'Do {max} €',
    priceRange: '{min} – {max} €',
    remove: 'Odebrat filtr: {filter}',
  },
  sort: {
    label: 'Řazení:',
    newest: 'Nejnovější',
    priceAsc: 'Cena ↑',
    priceDesc: 'Cena ↓',
    nameAsc: 'Název A–Z',
  },
  platformNav: {
    ariaLabel: 'Filtrovat podle platformy',
    all: 'Všechny platformy',
    gameGoods: 'Herní zboží',
    other: 'Ostatní',
    showAll: 'Zobrazit vše',
  },
  toolbar: {
    // Pouze slovo v množném čísle: číslo se vykresluje zvlášť jako velký počet.
    results: 'výsledek | výsledky | výsledků',
    gridViewAriaLabel: 'Zobrazení v mřížce',
    listViewAriaLabel: 'Zobrazení v seznamu',
  },
  empty: 'Žádné produkty neodpovídají vašim filtrům',
  emptyHint: 'Zkuste odebrat některý filtr nebo rozšířit cenové rozpětí.',
  errorBody: 'Katalog se nepodařilo načíst. Zkontrolujte připojení a zkuste to znovu.',
  pagination: {
    label: 'Stránkování',
    previousAriaLabel: 'Předchozí stránka',
    nextAriaLabel: 'Další stránka',
  },
  quickView: {
    label: 'Rychlý náhled',
    open: 'Rychlý náhled: {name}',
    viewFullPage: 'Zobrazit celou stránku',
  },
};
